import { externalServices } from '@/plugins/axios'
import { getDataFromLocalStorage } from '@/helpers/helpers'

export const lexboxPutData = async (url: string, data: object): Promise<any> => {
  const authData = getDataFromLocalStorage('authData')
  const accessToken = authData?.accessToken || ''
  const response = await externalServices.put(url, data, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
  })
  if (!response || response.status !== 200) {
    return null
  }
  return response.data
}

export const lexboxGetData = async (url: string): Promise<any> => {
  const authData = getDataFromLocalStorage('authData')
  const accessToken = authData?.accessToken || ''
  const response = await externalServices.get(url, {
    headers: { Authorization: `Bearer ${accessToken}` }
  })
  if (!response || response.status !== 200) {
    return null
  }
  return response.data
}
